export default "__VITE_ASSET__Dbz0q1zF__"